import { Theme } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles<Theme>(({ palette, spacing }) => {
  return {
    containerRoot: {
      backgroundColor: palette.background.default,
      paddingTop: spacing(8),
      paddingRight: spacing(6),
      paddingBottom: spacing(8),
      paddingLeft: spacing(6),
      maxWidth: 960,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      flexGrow: 1,
    },
    layoutRoot: {
      display: "flex",
      flexDirection: "column",
      minHeight: "100vh",
      margin: 0,
      padding: 0,
    },
  };
});

export default useStyles;
